import React from "react";
import Input from "../Components/shared/Input";
import topTost from "./topTost";
import { fetchFormData } from "./options";
const SettledModal = ({
  show,
  onClose,
  onConfirm,
  isSettled,
  setIsSettled,
  transactionDetails,
  setTransactionDetails,
  selectedInquiryId,
  payoutDate,
  setPayoutDate,
  payoutType,
  setPayoutType,
  remark,
  setremark,
}) => {
  const today = new Date().toISOString().split("T")[0];

  if (!show) return null;
  const userId = localStorage.getItem("id");
  const handleConfirm = async () => {
    if (isSettled && transactionDetails.trim() === "") {
      topTost({
        title: "Transaction details are required when marked as settled.",
        icon: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("id", selectedInquiryId);
    formData.append("IsPaid", isSettled ? 1 : 0);
    formData.append("TransitionID", transactionDetails);
    formData.append("PayoutDate", payoutDate);
    formData.append("payouts_type", payoutType);
    formData.append("remark", remark);
    formData.append("userId", userId);

    try {
      const response = await fetchFormData(
        "update-loan-payout",
        formData,
        "POST"
      );
      if (response?.code === 200 || response?.code === 201) {
        topTost({
          title: response.message || "Loan payout details updated successfully",
          icon: "success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        topTost({
          title: response.message || "Something went wrong!",
          icon: "error",
        });
      }
    } catch (error) {}
  };

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      role="dialog"
      style={{ backdropFilter: "blur(4px)" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Mark as Settled</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="form-check mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="settledCheckbox"
                checked={isSettled}
                onChange={(e) => setIsSettled(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="settledCheckbox">
                Is Settled?
              </label>
            </div>
            {isSettled && (
              <>
                <div className="mb-3">
                  <label className="form-label">Transaction ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={transactionDetails}
                    onChange={(e) => setTransactionDetails(e.target.value)}
                    placeholder="Enter transaction ID"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Payout Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={payoutDate}
                    onChange={(e) => setPayoutDate(e.target.value)}
                    min={today}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Payout Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={payoutType}
                    onChange={(e) => setPayoutType(e.target.value)}
                    placeholder="Enter Payout Type"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Remark</label>
                  <input
                    type="text"
                    className="form-control"
                    value={remark}
                    onChange={(e) => setremark(e.target.value)}
                    placeholder="Enter remark"
                  />
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettledModal;
